module.exports = function (element) {
    function markBlock(el) {
        var node = $(el);
        var links = node.find('a');
        var url = $(el).data('url')
        var tex = node.find('.vote')

        links.on({
            click: function () {
                if ($(".mark_block .mark_bw").length == 0 || $(this).hasClass("mark_bw")) {
                    var m = parseFloat($(this).attr("href").slice(1));

                    links.addClass("disable");
                    $(this).removeClass("disable");

                    $.post(url, {'m': m}, function (data) {
                        tex.text(data.result);
                    }, 'json');
                }

                gtag('event', 'vote_add', {
                    'event_category': 'vote',
                    'event_label': m
                });

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    markBlock(element);
};
